
import { Component, Vue, Prop } from 'vue-property-decorator';
import IdDocType from '@/resources/enum/IdDocType';
import { is, isGeneralCard, isPassport } from '@/util/idDoc';
import { TranslateResult } from 'vue-i18n';

@Component
export default class DiagonalHeader extends Vue {
  private get top(): number {
    return this.$store.state.camera.headerMarginHeight + 24;
  }

  private get isPaidy(): boolean {
    return this.$store.getters['auth/isPaidy'];
  }

  private get isIdDocPassport(): boolean {
    if (isPassport(this.$store.state.camera.idDocType) === true) return true;
    return false;
  }

  private get isIdDocHealthInsuranceCard(): boolean {
    if (is(this.$store.state.camera.idDocType, 'health-insurance-card')) return true;

    return false;
  }

  private get isGeneralCard(): boolean {
    if (isGeneralCard(this.$store.state.camera.idDocType) === true) return true;
    return false;
  }

  private get sentences(): TranslateResult[] {
    if (this.isIdDocPassport) {
      return [this.$t('202309_277'), this.$t('202309_268'), this.$t('202309_2681'), this.$t('202309_2682')];
    } else if (this.isIdDocHealthInsuranceCard || this.isGeneralCard) {
      return [this.$t('202309_228'), this.$t('202309_006')];
    } else {
      return [this.$t('202309_228'), this.$t('202309_006'), this.$t('202309_0061'), this.$t('202309_0062')];
    }
  }
}
